<template>
  <button type="button" class="btn btn-link" @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
export default {
  emits: ['click']
}
</script>
